// -------------------------------------
//  ScrollPosition
// -------------------------------------
export default function ScrollPosition(){
  var headerHeight = $('header').outerHeight();
  var urlHash = location.hash;
  if(urlHash) {
    var target = jQuery(urlHash == "#" || urlHash == "" ? 'html' : urlHash);
    var position = target.offset().top-headerHeight;
    $('body,html').animate({scrollTop:position},600, 'swing');
    return false;
  }
  $('a[href^="#"]').on('click', function(){
    var href= $(this).attr("href");
    var target = jQuery(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-headerHeight;
    $('body,html').animate({scrollTop:position}, 600, 'swing');
    return false;
  });
}
